import { defineComponent as _defineComponent } from 'vue'
import { onMounted, ref } from 'vue';
import { useRouter } from 'vue-router/composables';

import {
  NavBar,
  Heading,
  Grid,
  LoaderIndicator,
  HelperViewStatus,
  ButtonContainer,
  ButtonPrimary
} from '@warrenbrasil/nebraska-web';
import { BackButton } from '@/modules/common/components/buttons/BackButton';
import { PortfolioCardV2 } from '@/modules/wealth/components/PortfolioCardV2';

import { getPortfoliosToInvest } from '@/modules/wealth/services/investment';
import { IPortfolioList, PortfolioCategories } from '@/types/models/Portfolio';


export default /*#__PURE__*/_defineComponent({
  __name: 'WealthInvest',
  props: {
    renderAsView: { type: Boolean, default: true }
  },
  setup(__props: any) {



const router = useRouter();

const portfolioList = ref<IPortfolioList[]>([]);
const isLoading = ref(false);
const hasError = ref(false);

function gotToinvest(portfolio: IPortfolioList) {
  const routerName: Record<PortfolioCategories, string> = {
    [PortfolioCategories.Custom]: 'wealthProductTransaction',
    [PortfolioCategories.VariableIncome]: 'variableIncomeInvestment',
    [PortfolioCategories.WarrenManagement]: 'investment-transaction'
  };

  const paramsMapper: Record<PortfolioCategories, object> = {
    [PortfolioCategories.Custom]: { id: portfolio.id },
    [PortfolioCategories.VariableIncome]: { id: portfolio.id },
    [PortfolioCategories.WarrenManagement]: { portfolio: portfolio.id }
  };

  router.push({
    name: routerName[portfolio.type],
    params: { ...paramsMapper[portfolio.type] }
  });
}

function goToCatalog() {
  router.push({ name: 'catalog' });
}

async function fetchPortfolios() {
  isLoading.value = true;
  hasError.value = false;

  try {
    portfolioList.value = await getPortfoliosToInvest();
  } catch (error) {
    hasError.value = true;
  } finally {
    isLoading.value = false;
  }
}

onMounted(() => {
  fetchPortfolios();
});

return { __sfc: true,router, portfolioList, isLoading, hasError, gotToinvest, goToCatalog, fetchPortfolios, NavBar, Heading, Grid, LoaderIndicator, HelperViewStatus, ButtonContainer, ButtonPrimary, BackButton, PortfolioCardV2 }
}

})